// hook dependancies
import { useGlobal, setGlobal } from "reactn";

// helpers
import { capitaliseFirstLetters } from "../helpers/Helpers";

/**
 *
 */
const Hook = () => {
    const [profile] = useGlobal("profile");
    const [values] = useGlobal("values");
    const [activeTab] = useGlobal("activeTab");
    const [addressObj] = useGlobal("addressObj");

    const setGlobalValue = (id, value) => {
        setGlobal({
            values: { ...values, [id]: value }
        });
    };

    const refreshGlobalVals = updatedVals => {
        setGlobal({
            values: updatedVals
        });
    };

    const setProfileData = profileData => {
        setGlobal({
            values: { ...values, profile: profileData }
        });
    };

    const setActiveTab = name => {
        setGlobal({
            activeTab: name
        });
    };


    const checkForMobileNumber = phones => {
        let mobileNumber = "";
        for (let i = 0; i < phones.length; i += 1) {
            if (phones[i].type.toUpperCase() === "MOBILE") {
                mobileNumber = phones[i].number;
            }
        }
        return mobileNumber;
    };

    const getDefaultAddress = (addresses, type) => {
        for (let i = 0; i < addresses.length; i += 1) {
            if (addresses[i].displayName === type) {
                return addresses[i];
            }
        }
        return null;
    };

    // Format address for display on the Profile Info Page
    const formatAddress = address => {
        if (!address) return null;

        return `${address.organisationName ? capitaliseFirstLetters(address.organisationName) : ""} 
        ${address.addressLine1 ? capitaliseFirstLetters(address.addressLine1) : ""} 
        ${address.addressLine2 ? capitaliseFirstLetters(address.addressLine2) : ""} 
        ${address.addressLine3 ? capitaliseFirstLetters(address.addressLine3) : ""} 
        ${address.addressLine4 ? capitaliseFirstLetters(address.addressLine4) : ""} 
        ${address.city ? capitaliseFirstLetters(address.city) : ""} 
        ${address.town ? capitaliseFirstLetters(address.town) : ""}
        ${address.county ? capitaliseFirstLetters(address.county) : ""}
        ${address.country ? capitaliseFirstLetters(address.country) : ""}
        ${address.eircode && address.country && address.country.toUpperCase() === "IRELAND" ? address.eircode.toUpperCase() : ""} 
        ${address.postcode && address.country && address.country.toUpperCase() !== "IRELAND" ? address.postcode.toUpperCase() : ""}`;
    };

    return {
        setGlobalValue,
        refreshGlobalVals,
        setProfileData,
        checkForMobileNumber,
        getDefaultAddress,
        formatAddress,
        setActiveTab,
        activeTab,
        addressObj,
        profile,
        values
    };
};

export default Hook;
